module.exports = __webpack_public_path__ + "img/reais.53790583.svg";